<template lang="html">
    <div class="page">
        <header class="pageHeader rounded darken">
            <fade-image class="darken" src="assets/headers/messages.png" />
        </header>

        <div class="scroller2">
            <header>
                <h2>Message Inbox</h2>

                <ul class="links">
                    <li style="transform: translateY(-2px)">
                        <button
                            class="openSettings"
                            @click.prevent="deleteOn = !deleteOn"
                            type="button"
                            name="button"
                        >
                            <img class="bin" v-if="!deleteOn" src="@/assets/bin.svg" /><img
                                v-else
                                class="bin"
                                src="@/assets/bin-red.svg"
                            />
                        </button>
                    </li>
                    <li>
                        <router-link class="cancel" :to="{ name: 'proMessages' }"
                            ><x-icon class="icon"
                        /></router-link>
                    </li>
                </ul>
            </header>

            <ul id="messages" v-if="messages.length > 0">
                <message-item
                    v-for="message in messages"
                    :showFrom="true"
                    :key="message.id"
                    :message="message"
                    :deleteOn="deleteOn"
                />
            </ul>

            <span class="info" v-else>You have no messages</span>
        </div>
    </div>
</template>

<script>
import FadeImage from "@/components/App/fade-image";
import { XIcon } from "vue-feather-icons";
import MessageItem from "@/components/Pro/Messages/Message-item";
export default {
    name: "inbox",
    components: {
        MessageItem,
        XIcon,
        FadeImage,
    },
    created() {
        this.$store.dispatch("getMessages");
    },
    computed: {
        messages() {
            return this.$store.state.messages;
        },
    },
    data() {
        return {
            deleteOn: false,
        };
    },
};
</script>

<style lang="scss"></style>
